import examplePage from "./pages/exampleModelPage";

const pages = {
    examplePage: examplePage
}

export default pages;   